import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=4feefc53&scoped=true"
import script from "./Base.vue?vue&type=script&lang=ts"
export * from "./Base.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feefc53",
  null
  
)

export default component.exports